import { useState, useCallback } from 'react';

export function useForm(initialValues) {
    const [values, setValues] = useState(initialValues || {});

    const setValue = useCallback(
        (field, v) => {
            setValues((vs) => {
                const newValue = { ...vs };
                newValue[field] = v;
                return newValue;
            });
        },
        [setValues]
    );

    const getValue = useCallback(
        (field) => {
            return values[field];
        },
        [values]
    );

    return { values, setValue, getValue };
}